import { Form, Input, Select, Checkbox } from 'antd'
import { func, number, object } from 'prop-types'
import React, { useState } from 'react' // Add useState import
import { useDispatch, useSelector } from 'react-redux'
import Delete from '~/components/deleteConfirm'
import DragDropCard from '~/components/dragDropCard'
import {
	editTemplateMove,
	editTemplateStepRemove,
} from '~/states/modules/editTemplate'
import { listTemplate } from '~/states/modules/templates'

const DerivedDocumentStep = ({ form, step, index, updateStep }) => {
	const dispatch = useDispatch()
	const [addAttachmentIsChecked, setAddAttachment] = useState(
		step.add_attachment
	)
	const [templatesLoaded, setTemplateLoaded] = useState(false)

	const updateStepProperty = (propertyName, propertyValue) => {
		updateStep(index, { [propertyName]: propertyValue })
	}

	const templateSelectOptions = useSelector(({ template }) => {
		if (template.data.length === 0 && !templatesLoaded) {
			dispatch(listTemplate({ published: true, perPage: 1000 }))
			setTemplateLoaded(true)
		}
		return template.data.map((template) => {
			return { value: template.id, label: template.name }
		})
	})

	const handleRemoveStep = () => {
		dispatch(editTemplateStepRemove({ index }))
	}

	const handleCheckboxChange = (event) => {
		const checked = event.target.checked
		updateStepProperty('add_attachment', checked ? 1 : null)
		setAddAttachment(checked) // Show/hide text input based on checkbox value
	}

	return (
		<DragDropCard index={index} move={editTemplateMove} name={'workflow'}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					height: '32px',
					marginBottom: '24px',
				}}>
				<Form.Item
					name={['description', index]}
					label="Descrição"
					rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
					initialValue={step.title}>
					<Input
						onChange={(event) => {
							updateStepProperty('title', event.target.value)
						}}
					/>
				</Form.Item>
				<Delete
					handle={() => handleRemoveStep()}
					title="Deseja excluir esse passo?"
				/>
			</div>
			<Form.Item name={['addAttachment', index]} label={'Adicionar anexo'}>
				<Checkbox
					checked={step.add_attachment}
					onChange={handleCheckboxChange}></Checkbox>
			</Form.Item>
			{addAttachmentIsChecked && (
				<Form.Item
					name={['attachmentVariableName', index]}
					label={'Nome da variavel de anexo'}
					initialValue={step.attachment_variable_name}>
					<Input
						onChange={(event) => {
							updateStepProperty('attachment_variable_name', event.target.value)
						}}
					/>
				</Form.Item>
			)}
			<Form.Item
				name={['template', index]}
				label="Selecione o modelo do documento derivado"
				initialValue={step.template}
				rules={[{ required: true, message: 'Este campo é obrigatório.' }]}>
				<Select
					allowClear
					style={{ width: '100%' }}
					placeholder="Selecione o template"
					options={templateSelectOptions}
					onSelect={(value) => updateStepProperty('template', value)}
				/>
			</Form.Item>
		</DragDropCard>
	)
}

export default DerivedDocumentStep

DerivedDocumentStep.propTypes = {
	form: object,
	step: object,
	index: number,
	updateStep: func,
}

DerivedDocumentStep.defaultProps = {
	groups: [],
}
